// extracted by mini-css-extract-plugin
export default {"options":"AdminTab_options__Obsr4"};